export function useClearCookies() {
  // document is unavailable during SSR; cookie clearing only makes sense
  // in the browser (this runs on logout, a client-side action).
  if (import.meta.server) return;

  const cookies = document.cookie.split("; ");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
  }
}